import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorService } from '@services/error.service';
import { SessionService } from '@services/session.service';
import { Location } from '@angular/common';
import { DangerError, WarningError } from '@shared/errors/custom.error';
import { LicenciaService } from '@services/licencia.service';
import { BaseFuncionalidadComponent } from '@shared/base/base-funcionalidad.component';
import { Archivo } from '@models/archivo.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StateService } from '@services/state.service';
import { TerminologiaService } from '@services/terminologia.service';
import { Mensajes } from '@shared/enums/mensajes.enum';
import AccionesFuncionalidad from '@shared/enums/acciones.enum';

@Component({
    selector: 'app-expedientes-detalle-subir-documentos',
    templateUrl: './expedientes-detalle-subir-documentos.component.html',
    styleUrls: ['./expedientes-detalle-subir-documentos.component.scss']
})
export class ExpedientesDetalleSubirDocumentosComponent extends BaseFuncionalidadComponent {
    constructor(
        sessionService: SessionService,
        route: ActivatedRoute,
        location: Location,
        router: Router,
        stateService: StateService,
        private errorService: ErrorService,
        private licenciaService: LicenciaService,
        private sanitizer: DomSanitizer,
        private terminologiaService: TerminologiaService
    ) {
        super(route, sessionService, location, router, stateService);
    }

    isLoading = false; // Variable que maneja el renderizado del spinner de carga inicial

    mostrarModal = false; // Variable que maneja el renderizado del modal

    documentoCargado: Archivo; // Variable que guarda el documento seleccionado
    urlTemporal: SafeResourceUrl; // Variable que guarda la url temporal del documento cargado

    isPDF: boolean; // Variable que maneja si el documento es un pdf
    mensajeExito: string; // variable que guarda el mensaje de exito en la acción del expediente

    ngOnInit() {
        if (this.documento) {
            const doc = this.documento;
            this.name = "Reemplazar Documento";
            this.isPDF = doc.extension === 'pdf';
            this.urlTemporal = this.sanitizer.bypassSecurityTrustResourceUrl(this.documento.url_documento);
            this.documento = doc;
        }
    }
  
    get mensajeSinPermisos(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_funcionalidad);
    }

    get mensajeSinPermisosAccion(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_accion);
    }

    get mensajeGuardarDocumento(): string {
        return this.terminologiaService.obtenerMensajePorID(this.documento ? Mensajes.reemplazar_documento : Mensajes.guardar_documento);
    }

    get rutaTipoDocumento(): string {
        return this.tipoDocumento.ruta;
    }

    get tituloPagina(): string {
      return this.idAccion === AccionesFuncionalidad.ingresar_antecedentes ? "Ingresar Documento" : this.titulo;
    }

    asignarDocumento(file: Archivo) {
        file.tipo = this.tipoDocumento;
        this.documentoCargado = file;
        this.isPDF = this.documentoCargado?.mime === 'application/pdf';
    }

    abrirModal() {
        this.mostrarModal = true;
    }

    async guardarDocumentos() {
        this.isLoadingModal = true;
        try {
            if (!this.canAddDoc) throw new DangerError(this.mensajeSinPermisosAccion);
            if (!this.documentoCargado) throw new WarningError("Debe seleccionar un documento.");

            this.mensajeExito = await this.licenciaService.ingresarDocumentosLicencia(this.id, this.licencia.id, this.documentoCargado, this.documento ? true : false);
            this.mostrarModal = false;
            this.mostrarModalConfirmacion = true; // Encadena el modal de confirmación tras aceptar
        } catch (error) {
            this.errorService.handle(error, "Se produjo un error al crear el expediente.");
        } finally {
            this.isLoadingModal = false;
        }
    }

    onModalConfirmacionCerrado() { // Vuelve atras al cerrar el modal de confirmación
        this.mostrarModalConfirmacion = false;
        if (this.documento) this.volverDosPaginasAtras();
        else this.volverAtras();
    }

    obtenerUrlTemporal(url: SafeResourceUrl) {
        this.urlTemporal = url;
    }


}
